import React, { useEffect, useState } from 'react'
import classes from "./MatchDetails2.module.css";
import { FaArrowLeft, FaCircle, FaMinus } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';
import { matchDetailsApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import Lineups2 from '../../component/NewComponents/Lineups2';
import MatchStats2 from '../../component/NewComponents/MatchStats2';
import { teamStatsCalculator } from '../../utils/helper';
import MatchEvents2 from '../../component/NewComponents/MatchEvents2';
import moment from 'moment-timezone';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const MatchDetails2 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [matchDetails, setMatchDetails] = useState(null);
    const [matchDetails2, setMatchDetails2] = useState(null);
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const [tab, setTab] = useState("lineups");
    const [teamStatistics, setTeamStatistics] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const fetchMatchDetails = async (match_fixture_id, load) => {
        try {
            if (load) setLoading(true);
            setLoader(true);
            const response = await matchDetailsApi(match_fixture_id, userDetails?.token);
            setMatchDetails(response?.data);
            setMatchDetails2(JSON.parse(response?.data?.match_details));
            setTeamStatistics(teamStatsCalculator(JSON.parse(response?.data?.match_details), response?.data?.home_team_id, response?.data?.away_team_id));
            setLoading(false);
            setLoader(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("48"));
                navigate('/');
            } else {
                setLoading(false);
                setLoader(false);
                console.log(error, 'error---');
            }
        }
    };

    useEffect(() => {
        if (location?.state?.match_fixture_id) {
            fetchMatchDetails(location?.state?.match_fixture_id, true);
        } else {
            navigate("/home");
        }
    }, [location?.state?.match_fixture_id]);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchMatchDetails(location?.state?.match_fixture_id, false);
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }
    }, [loader]);

    const renderStatus = () => {
        const s = matchDetails?.match_status;
        const elapsed = matchDetails2?.fixture?.status?.elapsed;
        const extra = matchDetails2?.fixture?.status?.extra;

        if (["FT", "AET", "PEN"].includes(s)) return <span className={classes.status_text}>{t("87")}</span>;
        if (s === "SUSP") return <span className={classes.status_text}>{t("88")}</span>;
        if (s === "PST") return <span className={classes.status_text}>{t("89")}</span>;
        if (s === "CANC") return <span className={classes.status_text}>{t("90")}</span>;
        if (["ABD", "AWD", "WO"].includes(s)) return <span className={classes.status_text}>{t("91")}</span>;
        if (s === "HT") return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{t("92")} {elapsed}`</span>;
        if (s === "ET") return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{elapsed}` ET +{extra}`</span>;
        if (s === "P") return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{t("93")} {elapsed}`</span>;
        if (["1H", "2H", "LIVE"].includes(s)) return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{elapsed}`</span>;
        return null;
    };

    return (
        <div className={classes.page}>
            <div className={classes.pageInner}>

                {/* Sticky header */}
                <div className={classes.header}>
                    <div className={classes.header_nav}>
                        <div className={classes.header_nav_container}>
                            <button type="button" className={classes.back_button} onClick={() => navigate("/home")}>
                                <FaArrowLeft className={classes.back_icon} />
                            </button>
                        </div>
                    </div>

                    {loading ? (
                        <div style={{ padding: "20px", display: "flex", justifyContent: "center", background: "var(--green-deep)" }}>
                            <SmallLoader />
                        </div>
                    ) : (
                        <div className={classes.match_details_container}>
                            {renderStatus() && (
                                <div className={classes.match_status}>{renderStatus()}</div>
                            )}

                            <div className={classes.match_details}>
                                <div className={classes.team}>
                                    <img src={matchDetails?.home_team_image} alt={matchDetails?.home_team_name} className={classes.team_logo} />
                                    <span className={classes.team_name}>{matchDetails?.home_team_name}</span>
                                </div>
                                <div className={classes.score_container}>
                                    <span className={classes.score}>{matchDetails2?.goals?.home ?? "-"}</span>
                                    <div className={classes.separator}><FaMinus className={classes.separator_icon} /></div>
                                    <span className={classes.score}>{matchDetails2?.goals?.away ?? "-"}</span>
                                </div>
                                <div className={classes.team}>
                                    <img src={matchDetails?.away_team_image} alt={matchDetails?.away_team_name} className={classes.team_logo} />
                                    <span className={classes.team_name}>{matchDetails?.away_team_name}</span>
                                </div>
                            </div>

                            <span className={classes.match_time}>
                                {moment.utc(matchDetails?.match_date_time).local().format("dddd, DD MMM YYYY [at] hh:mm A")}
                            </span>
                        </div>
                    )}

                    <div className={classes.tabs_container}>
                        {["lineups", "stats", "events"].map(ta => (
                            <button
                                key={ta}
                                type="button"
                                className={`${classes.tab_option} ${tab === ta ? classes.active : ''}`}
                                onClick={() => setTab(ta)}
                            >
                                {ta == "lineups" ? t("114") : ta == "stats" ? t("115") : t("116")}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Tab content */}
                {loading ? (
                    <div style={{ padding: "40px", display: "flex", justifyContent: "center" }}>
                        <SmallLoader />
                    </div>
                ) : (
                    <div className={classes.content}>
                        {matchDetails2 && tab === "lineups" ? (
                            <Lineups2 homeTeam={matchDetails2?.lineups?.[0]} awayTeam={matchDetails2?.lineups?.[1]} />
                        ) : tab === "stats" ? (
                            <MatchStats2 teamStatistics={teamStatistics} />
                        ) : tab === "events" ? (
                            <div className={classes.grid_col_2}>
                                <MatchEvents2
                                    team_name={matchDetails?.home_team_name}
                                    data={matchDetails2?.events?.filter(d =>
                                        d?.team?.name == matchDetails?.home_team_name &&
                                        d?.type == "Goal" &&
                                        d?.detail != "Missed Penalty"
                                    )}
                                />
                                <MatchEvents2
                                    team_name={matchDetails?.away_team_name}
                                    data={matchDetails2?.events?.filter(d =>
                                        d?.team?.name == matchDetails?.away_team_name &&
                                        d?.type == "Goal" &&
                                        d?.detail != "Missed Penalty"
                                    )}
                                />
                            </div>
                        ) : null}
                    </div>
                )}

            </div>
        </div>
    );
};

export default MatchDetails2;